export default function remCalc(px: number): number {
  const base = 16;
  return (1 / base) * px;
}
